import {
  Component,
  AfterViewInit,
  Input,
  OnDestroy,
  OnInit,
  Injector,
  OnChanges,
  SimpleChanges,
  HostListener,
  Output,
  EventEmitter,
} from "@angular/core";
import { DatePipe } from "@angular/common";
import { MapConstants } from "src/app/utils/map.constant";
import * as L from "leaflet";
import "src/assets/leaflet-velocity-src/js/windy.js";
import "src/assets/leaflet-velocity-src/js/L.VelocityLayer.js";
import "src/assets/leaflet-velocity-src/js/L.Control.Velocity.js";
import "src/assets/leaflet-velocity-src/js/L.CanvasLayer.js";
import "src/assets/leaflet-spin/leaflet.spin.js";
import "src/assets/leaflet-spin/leaflet.spin.min.js";
import "src/assets/leaflet-image-transform/L.ImageTransform.js";
import { UtilsService } from "src/app/utils/utils.service";
import "src/assets/map-control/L.Control.ZoomBar.js";
import "leaflet.vectorgrid";
import { ProjConstants } from "src/app/utils/proj.constant";
import { Chartconstant } from "src/app/utils/chart.constant";
import { Router, ActivatedRoute } from "@angular/router";
import "src/assets/leaflet-geojson-tilelayer/TileLayer.GeoJSON.js";
import { MapService } from "src/app/utils/map.service";
import { isNullOrUndefined } from "util";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as turf from "@turf/turf";
import { ShareModalComponent } from "../share-modal/share-modal/share-modal.component";
import { DrinkingWaterDataService } from "../../side-bar/drinking-water-stress/drinking-water-data.service";
import { DrinkingWaterMapConstants } from "../../side-bar/drinking-water-stress/drinking-water-gis/drinking-water.constant";
import { DeviceDetectorService } from "ngx-device-detector";
import { InfomodalComponent } from "../infomodal/infomodal.component";
import { ToastrService } from "ngx-toastr";
// import { TranslateService } from '@ngx-translate/core';
import { resolve } from "url";
import { LightningDataService } from "../../side-bar/lightning/lightning-data.service";
import { LightningMapService } from "../../side-bar/lightning/lightning-map.service";
import { HeatIndexDataService } from "../../side-bar/heat-index/heat-index-data.service";
import { count, log } from "console";
import { CookieService } from "ngx-cookie-service";
import { HttpClient } from "@angular/common/http";
import 'src/assets/js/maplibs/L.TileLayer.NoGap.js'
import { isEmptyObject } from "jquery";
@Component({
  selector: "app-gis-map",
  templateUrl: "./gis-map.component.html",
  styleUrls: ["./gis-map.component.scss"],
})
export class GisMapComponent
  implements OnInit, AfterViewInit, OnDestroy, OnChanges
{
  visitorCount: any = '6000';
  districtClickedSubscription: any;
  observedWeather: any;
  adminBasinSubscription: any;
  ruralUrbanSubscription: any;
  forecastLengthSubscription: any;
  toggleSubscription: any;
  timeStampList: {};
  revalidateMapSubscription: any;
  selectedLocation: any;
  dataTabToggleVal = false;
  activeLayers: any = [];
  view: string;
  activeGroup: any;
  leftSideBarSubscription: any;
  apiData: any;
  type: string;
  apiParams: any;
  minMax: any;
  STATENAME: any;
  serviceMap: any;
  urlParams: any;
  bottomBarComponent: any;
  legend: any;
  thresholdMap: object;
  initialCounter: number;
  counter: number;
  style = {
    stroke: false,
    color: "#FF0000",
    fill: true,
    fillColor: "#FF0000",
    fillOpacity: 0.4,
    opacity: 0.4,
  };
  componentType: string;
  hourCounter = "";
  blockNumber = 0;
  dateBlockNumMap = {};
  playPosition = 0;
  collapsebutton: any;
  activeSideMenu: any;
  polygons = [];
  bottombarClick: boolean;
  selectedComponent: string;
  meanMedian: string;
  showOption = false;
  selectedOption: any;
  application: string;
  villageLayerSubscription: any;
  villageLayer: {
    layerNameType: string;
    layerName: string;
    serviceType: string;
    view: string;
    type: string;
    name: string;
    minZoom: number;
    visible: boolean;
    CQL_FILTER: any;
  };
  // villageLayer: { layerNameType: string; layerName: string; serviceType: string; view: string; type: string; name: string; minZoom: number; visible: boolean; };
  rUview: string;
  MLayerGrp: any;
  mapLayerGroup: any;
  ulbNameLayer = new (L as any).layerGroup();
  isallUlbsAdded: boolean = false;

  isUlbMarkerClicked: boolean = false;
  forNames = [];
  ulbLayer: {
    layerNameType: string;
    layerName: string;
    serviceType: string;
    view: string;
    type: string;
    name: string;
    minZoom: number;
    visible: boolean;
    CQL_FILTER: any;
  };
  UrbanLayerSubscription: any;
  ulbCentroidData: any;
  allUlbLayer: any;
  allUlbNames = new (L as any).layerGroup();
  deviceInfo: any;
  screenWidth: number;
  sourceList: string[] = ["ECMWF", "IMD"];
  activeSource: string;
  stateUrlId: string;
  selectedComponentType: string;
  selectedWeather: string;
  sourceDropdown: any[];
  showLegand = true;
  showOptions = false;
  optionAndClose = "Options";
  villageWMSLayer: any;
  isLoggedIn: boolean = false;
  showLogin: boolean = false;
  @Output() loginStatus = new EventEmitter<boolean>();
  lang: string;
  TLayerGrp: any;
  currentLatLng = {};
  stateSubscription: any;
  stateClicked: any;
  countrySubscription: any;
  countryClicked: any;
  modalRef: any;
  districts: {};
  states: {};
  stateSelectedCheck = false;
  Value: any;
  showHWdownload: boolean = false;
  //To set the breadcrumbs
  stateSelect = {
    name: "",
    centroid: null,
    uuid: null,
  };
  districtSelect = {
    name: "",
    centroid: null,
    uuid: null,
  };

  //for Breadcrumb conditions
  stateWise: boolean = true;
  districtWise: boolean = false;
  countryWise: boolean = true;
  stateSelection: any;
  flags: boolean;

  //for Total conditions
  countryName: boolean = true;
  districtName: boolean = false;
  stateName: boolean = false;

  //Dropdown conditions
  showD1: boolean = true;
  showD2: boolean = false;

  //for login zoom
  stateUUId: string;
  lat: any;
  lon: any;
  centroid: any;
  isLoggedInUser: string;
  totalCount: any;
  downld: object[];
  userdetail: any = {};
  metadata: any = {};
  finalArray: any;
  displayTimestamp: any;
  locationData: any;
  selectedComponents: string;
  cityAlertsDisable:boolean = true;
  sourceData: any;
  nowcastView:any = 'Admin';
  applications: any;
  @Output() openTaskManager = new EventEmitter<any>();

  constructor(
    public DWSDataService: DrinkingWaterDataService,
    private utils: UtilsService,
    public mapService: MapService,
    private route: ActivatedRoute,
    public chartConstant: Chartconstant,
    private router: Router,
    private injector: Injector,
    public datepipe: DatePipe,
    private modalService: NgbModal,
    private deviceService: DeviceDetectorService,
    private toastr: ToastrService,
    private lightningMapService: LightningMapService,
    private heatIndexDataService: HeatIndexDataService,
    private cookie: CookieService,
    private http: HttpClient,
    private heatwaveDataService: HeatIndexDataService,
    private utilService : UtilsService,
    private datePipe: DatePipe
  ) {
    // const browserLang = translate.getBrowserLang();
    this.lang = localStorage.getItem("lang");
    this.lang = this.lang == "en" || this.lang == "te" ? this.lang : "en";
    // this.utils.setLanguage(browserLang);
    localStorage.setItem("lang", this.lang);
    // translate.use(browserLang.match(/en|te|hi/) ? browserLang : 'en');
    this.stateUrlId = this.route.snapshot.paramMap.get("id");
    this.STATENAME = ProjConstants.IDTOSTATENAMEMAPPING[this.stateUrlId];
    this.utils.setPopUpData({
      location: ProjConstants.IDTOLOCATIONMAPPING[this.stateUrlId],
    });
    this.setLocationData();
    // const mapoptions = mapService.getMapOptions(ProjConstants.STATENAME,ProjConstants)
    // console.log(mapoptions);
    this.selectedLocation = "";
    this.showThrobber = true;
    this.showBottomBar = false;
    this.bottomBarMenuSelectedIndex = 0;
    this.styleObjforBottomBar = { width: 0 };
    this.postData = {};
    this.bottomBarColumns.push("Component");
    this.geoJsonData = {};
    this.dateList = [];
    this.utils
      .getAdminBasinToggle()
      .subscribe((value) => {
        this.adminSelected = value;
        if (this.adminSelected == true) {
          this.view = "Admin";
        } else {
          this.view = "Basin";
        }
      })
      .unsubscribe();
    this.utils.minMax
      .subscribe((value) => {
        this.minMax = value;
      })
      .unsubscribe();
    this.forecastLength = this.route.snapshot.paramMap.get("time");
    this.utils.thresholdMap.subscribe((res: any) => {
      this.thresholdMap = res;
    });
    this.selectedComponent = router.url.split("/")[1];
    this.selectedComponents = router.url.split("/")[2];
    this.onResize();
    this.mapControlContainer();
    this.isLoggedInUser = localStorage.getItem("logIn");
  }
  // @ViewChild('myCanvas', { static: false }) myCanvas: ElementRef;
  @Input() mapData: any;
  @Input() component: any;
  @Input() index: any;
  @Input() count1: any;
  @Input() stateList: any;
  @Output() StateSelected = new EventEmitter<any>();
  @Output() districtSelected = new EventEmitter<any>();
  @Input() districtList: any;
  @Input() windData: any;
  @Input() blocksArray: any;
  @Input() mapDataForAllTs: any;
  @Input() windDataForAllTs: any;
  @Input() heatMapURLlist: any;
  @Input() windDataURLlist: any;
  @Input() layerList: any;
  @Input() tableDataComponent: any;
  @Input() otherOptions: any;
  @Input() basinGeoJSONData: any;
  @Input() giscolorsdata: any;
  @Input() legenddata: any;
  @Input() hidebottombar: any;
  @Input() sourceSelected: any;
  @Input() gistest: any;
  @Input() colorsData: any;
  @Input() ulbData: any;
  @Input() displayTime:any;
  @Input() timeStamp:any;
  RUEnabled: boolean;
  private map;
  flag = true;
  geoJsonData: any;
  playButtonDisable = true;
  indexForLeftPanel: any;
  citiesData: any;
  chartData: any = [];
  chartOptions: any;
  context: CanvasRenderingContext2D;
  tsArrayForPlay: any = [];
  tsLabelsArrayForPlay: any = [];
  direction: any;
  state = "stop";
  popUpData: any = {};
  postData: any;
  bottomBarData: any;
  bottomBarColumns: any = [];
  velocityLayer;
  wmsLayerGroup;
  allLayerList: any = [];
  overlayLayerList: any = [];
  geojsonLayerList: any = [];
  wmsLayerList: any = [];
  wmsUrl: any;
  wmsLayer: any;
  value: any = 3;
  imageUrl: any;
  adminSelected: any;
  ruralUrbanSelected: any;
  forecastLength: any;
  shortLongRange: any;
  imageBounds: any = [];
  playpause: boolean;
  startIndex = 1;
  imageLayer: any;
  showThrobber: any;
  bottomBarMenuSelectedIndex;
  styleObjforBottomBar = {};
  vectorTileLayer = {};
  labelStrings = [];
  marker = null;
  noData = false;
  blocks: any;
  Linechart: any;
  millisInSixHours = ProjConstants.MILLIS_IN_6HOURS;
  showBottomBar: any;
  districtClicked: object;
  particleMultiplier: any = 0.0006;
  showThrobberbottomBar = false;
  abbrvMapping = ProjConstants.COMPONENT_ABBREVIATION_MAPPING;
  heatMapoptions = {
    opacity: 0.8,
    pane: "heatMap",
    minZoom: 6,
    maxZoom: 15,
  };
  borderBottomBarStyle = {};
  // timestamp:;
  colorForBottomBar: any;
  nowForPlay: any;
  bottomBarDataWithStyle: any;
  bottomBarTableStyles: any = {};
  gradientColors: any = [];
  gradientStyles: any = {};
  heightHundred: any = {};
  gradient: any;
  blockLayer: any;
  customMarker = new L.icon({
    iconUrl:
      "https://upload.wikimedia.org/wikipedia/commons/9/93/Map_marker_font_awesome.svg",
    iconSize: [35, 41],
    iconAnchor: [14, 41],
    popupAnchor: [15, -40],
  });
  yAxisMin: any;
  chartTableData: any;
  chartGradient: any;
  dateList: any;
  clickedLocationMarker: any;
  clickedLocationTooltip: any;
  bottomTableKeys: any = [];
  playWidth: any = 3;
  stateBoundary: any;
  basinBoundary: any;
  activeTimePeriod: any;
  lastSource: string;
  htmlLegend: any;
  initialGroupName: any;
  fetchedUUID: any;
  selectedSource:any;
  locType:any = 'Country'
  activeButton:any = 'Admin'
  @Input() actualView:any = 'HeatMap';

  playFastSlow:boolean = false;
  titleTag = {
    'windspeed' : ' - 10m above surface',
    // 'rainfall' : '',
    'temperature' : ' - 2m above surface',
    'humidity' : ' - 2m above surface',
  }

  @HostListener("window:resize", ["$event"])
  onResize(event?) {
    this.screenWidth = window.innerWidth;
  }

  setComp(comp) {
    this.selectedWeather = comp;
    console.log("selectedComp", this.selectedWeather);
  }

  ngAfterViewInit(): void {
    this.showBottomBar = this.hidebottombar ? true : false;
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.initMap();
    this.addBaseLayers(this.layerList);
    if (
      this.selectedComponent !== "drinkingwaterstress" &&
      this.selectedComponent == "nowcastweather"
    ) {
      setTimeout(() => {
        this.serviceMap.addTimeBasedLayers(this, this.layerList);
      }, 3000);
    } else {
      this.serviceMap.addTimeBasedLayers(this, this.layerList);
    }

    // console.log(this.activeLayers);
    this.addSubscriptions();
    this.direction = {};
    // setTimeout(() => {
    //   this.map.eachLayer((layer) => {
    //     console.log("layer in map", layer);
    //   })
    // }, 10000)
    // this.popUpCurrentLocation()
    this.stateUUId = localStorage.getItem("uuid");
    this.lat = localStorage.getItem("lat");
    this.lon = localStorage.getItem("lon");
    this.centroid = [this.lat, this.lon];
    if (this.stateUUId) {
      setTimeout(() => {
        this.utils.setStateClicked(this.stateUUId);
      }, 3000);

      // this.map.setView(this.centroid,7)
    }

    // this.getStateUUID();
    return;
  }

  getWritableObject(obj: object): object {
    if (obj == null || obj == undefined) return obj;

    let objectConfig = {};
    for (let key in obj) {
      objectConfig[key] = obj[key];
    }

    return objectConfig;
  }
  // getStateUUID(){
  //   //header iff
  //   //fetch of user id from application storage
  //   //
  //   let UserID = ''
  //   let stateUUID : any[]
  //   this.http.get<any>(`http://heatwave.vassarlabs.com/umapi/api/user-permissions/${UserID}`).subscribe(data=>{
  //     Object.keys(data.response.permissions.HEATWAVE.userRoleScope.scope[0].scopeValue).forEach(key=>{

  //        stateUUID = data.response.permissions.HEATWAVE.userRoleScope.scope[0].scopeValue[key]
  //     })
  //   })
  //   console.log("stateUUID",stateUUID)
  //   setTimeout(()=>{

  // }

  popUpCurrentLocation() {
    if (
      this.router.url.split("/")[1] == "extremeweather" &&
      this.utils.getDeviceType() == "mobile"
    ) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            let coords = {
              lat: pos["coords"]["latitude"],
              lng: pos["coords"]["longitude"],
            };
            if (
              this.router.url.split("/")[1] == "extremeweather" &&
              this.utils.getDeviceType() == "mobile"
            ) {
              console.log(this.router.url.split("/")[1]);
              this.serviceMap.createPopUpAnyWhere(coords, this);
              this.setLocationName(coords);
              this.setLocationData();
            }
          },
          (error) => {
            if (error.PERMISSION_DENIED) {
              let urlParams = this.getWritableObject(
                this.route.snapshot.params
              );
              if (
                !isNullOrUndefined(urlParams["lat"]) &&
                !isNullOrUndefined(urlParams["lng"])
              ) {
                let coordsUrl = {
                  lat: urlParams["lat"],
                  lng: urlParams["lng"],
                };
                this.serviceMap.createPopUpAnyWhere(coordsUrl, this);
                this.setLocationName(coordsUrl);
                this.utils.setCurrentLatLongFromLS(coordsUrl);
                this.setLocationData();
              } else if (this.utils.getCurrentLatLongFromLS() != {}) {
                let coordsLocal = {
                  lat: this.utils.getCurrentLatLongFromLS()["lat"],
                  lng: this.utils.getCurrentLatLongFromLS()["lng"],
                };
                this.serviceMap.createPopUpAnyWhere(coordsLocal, this);
                this.setLocationName(coordsLocal);
                this.setLocationData();
              }
            }
          }
        );
      }
    }
  }

  setLocationName(latlng) {
    this.utils
      .getLocationLayerDataFromLatLong(
        latlng["lat"],
        latlng["lng"],
        "INDIA_BLOCK"
      )
      .subscribe((data) => {
        console.log("getLocationLayerDataFromLatLongawda", data);
        this.selectedLocation = data["features"][0]["properties"]["block"];
      });
  }
  manageSourceListAndActiveSource() {
    this.sourceList = [];
    this.utils.getSourceList().subscribe((list) => {
      this.sourceList = list;
    });
    this.utils.getIdmEcmwf().subscribe((activeSrc) => {
      this.activeSource = activeSrc.toString();
    });
  }
  ngOnInit() {
    this.lang = localStorage.getItem("lang");
    // this.translate.use(this.lang.match(/en|te|hi/) ? this.lang : 'en');
    this.applications = this.router.url.split('/')[2];

    this.utils.getLoginPrompt().subscribe((val) => {
      this.isLoggedIn = val;
    });

    this.utils.getLocationData().subscribe(source => {
      this.locationData = source;

    })

    if (localStorage.getItem("ACCESS_TOKEN")) {
      this.isLoggedIn = true;
    } else {
      this.isLoggedIn = false;
    }

    this.updateSource();
    this.utils.getShowDownload().subscribe((val) => {
      this.showHWdownload = val["download"];
      this.fetchedUUID = val["uuid"];
    });
    this.manageSourceListAndActiveSource();
    this.selectedComponentType = this.router.url.split("/")[2];
    if (this.router.url.split("/")[1] === "drinkingwaterstress") {
      // this.getUlbLocData();
      this.view = "Admin";
      this.utils.setULBselected(null);
      // this.adminSelected = true;
    }
    this.RUEnabled = false;
    this.application = this.router.url.split("/")[1];
    this.selectedComponentType = this.router.url.split("/")[2];
    if (this.router.url.split("/")[1] === "heatwatches") {
      this.dateBlockNumMap = this.heatwaveDataService.getLast7DaysDates();

      // const date = new Date();
      // const yesterdayDate = new Date(date);
      // yesterdayDate.setDate(date.getDate() -1)
      // for (let i = 0; i < 6; ++i) {
      //   this.dateBlockNumMap[
      //     this.datepipe.transform(date, "yyyy-MM-dd").split("-").join("")
      //   ] = i;
      //   date.setDate(date.getDate() + 1);
      // }
    } else if (
      this.router.url.split("/")[1] === "extremeweather" &&
      this.router.url.split("/")[2] === "rainfall" &&
      this.router.url.split("/")[3] === "24"
    ) {
      this.playPosition = 4;
    }
    if (
      this.router.url.split("/")[1] === "extremeweather" ||
      this.router.url.split("/")[1] === "observedweather" ||
      this.router.url.split("/")[1] === "heatwatches"
    ) {
      this.showOption = true;
    } else {
      this.showOption = false;
    }
    this.deviceInfo = this.deviceService.getDeviceInfo();
    setTimeout(() => {
      if (
        this.deviceInfo["deviceType"] === "desktop" &&
        this.screenWidth >= 768
      ) {
        this.type = this.router.url.split("/")[1];
      }
    }, 1000);
    this.utils.getStateClickedName().subscribe((value) => {
      //In order to set State breadcrumb and update tabledata
      this.StateSelected.emit({
        state: value.State_Name,
        stateUUID: value.State_UUID,
      });
      let centroid = { lat: value.Latitude, lon: value.Longitude };
      this.stateSelect.name = value.State_Name;
      this.stateSelect.uuid = value.State_UUID;
      this.stateSelect.centroid = centroid;
      this.stateName = true;
      this.countryName = false;
      this.districtWise = true;
      this.showD1 = false;
      this.showD2 = true;
    });

    this.utils.getStateClickedNameTable().subscribe((value) => {
      // In order to emit the clicked State from the table
      this.stateSelect.name = value.state;
      this.stateSelect.uuid = value.stateUUID;
      let centroid = { lat: value.centroid.lat, lon: value.centroid.lon };
      this.stateSelect.centroid = centroid;
      this.districtWise = true;
      this.stateName = true;
      this.showD1 = false;
      this.showD2 = true;
      this.countryName = false;
      this.locType = 'State'
      this.StateSelected.emit({
        state: value.state,
        stateUUID: value.stateUUID,
      });
    });
    this.utils.getDistrictClickedNameTable().subscribe((value) => {
      // In order to emit the clicked District from the table
      this.districtSelect.name = value.district;
      this.districtSelect.uuid = value.districtUUID;
      let centroid = { lat: value.centroid.lat, lon: value.centroid.lon };
      this.districtSelect.centroid = centroid;
      this.districtWise = true;
      this.showD2 = false;
    });
    this.utils.getBreadcrumbClick().subscribe((value) => {
      // Beadcrumb in table will reflect in Breadcrumb in map
      if (value == "Country") {
        this.countryWise = true;
        this.stateWise = true;
        this.districtWise = false;
        this.stateSelect.name = "";
        this.districtSelect.name = "";
        this.stateName = false;
        this.countryName = true;
        this.showD1 = true;
      } else if (value == "State") {
        this.stateWise = true;
        this.districtSelect.name = "";
        this.districtWise = false;
        this.showD1 = false;
        this.showD2 = false;
      }
    });
    if (this.cookie.get("loggedIn") == "true") {
      this.userdetail = this.checkloginstatus();
      this.userdetail["login"] = this.utils.checkUndefinedOrNull(
        this.userdetail["username"]
      );
    } else {
      this.router.navigate(["/login"]);
    }
    this.utils.setHeatWaveSource.subscribe(async data => {
      if (data) {
        this.selectedSource = data;
      }
    })

    // this.utils.getRadarSourceData().subscribe(source => {
    //   let dataSourcesTimeStamp = source;
    //   this.utils.getTimeStampData().subscribe(data => {
    //     // console.log(data,"data123");
    //     let timeStampData = data;
    //     if(dataSourcesTimeStamp == 'RICKEN'){
    //       this.displayTimestamp = this.formatDateString(timeStampData['RICKEN_NOWCAST']);
    //     }else if(dataSourcesTimeStamp == 'RADAR'){
    //       this.displayTimestamp = this.formatDateString(timeStampData['SIMPLE_RADAR_NOWCAST']);
    //     }else if(dataSourcesTimeStamp == 'IMD RADAR'){
    //       this.displayTimestamp = this.formatDateString(timeStampData['IMD_RADAR_NOWCAST']);
    //     }else if(dataSourcesTimeStamp == 'RADAR+CTT'){
    //       this.displayTimestamp = this.formatDateString(timeStampData['RADAR_CTT_EUMETSAT_NOWCAST']);
    //     }
    //   });
    // })
    this.utils.getRadarSourceData().subscribe(value=>{
      if(value == 'RADAR+CTT') {
        this.sourceData ='IMD, EUMETSAT'
      }else if(value == 'RICKEN'){
        this.sourceData ='JAXA'
      }else if (value == 'RADAR'){
        this.sourceData = 'RAIN VIEWER'
      }else if (value == 'IMD RADAR'){
        this.sourceData = 'IMD'
      }
    })
    this.dataTabToggle()
  }

  checkloginstatus() {
    return JSON.parse(this.cookie.get("userdetails"));
  }

  ngOnDestroy() {
    // this.forecastLengthSubscription.unsubscribe();
    // this.adminBasinSubscription.unsubscribe();
    // this.districtClickedSubscription.unsubscribe();
    this.setInitial();
    // this.villageLayerSubscription.unsubscribe();
    // this.leftSideBarSubscription.unsubscribe();
  }

  ngOnChanges(change: SimpleChanges) {
    if (this.selectedWeather) {
      this.manageSourceListAndActiveSource();
    }
    if (this.map) {
      if (
        isNullOrUndefined(this.otherOptions.changeStateBoolean) ||
        this.otherOptions.changeStateBoolean
      ) {
        this.changeStateBasedonUrlParams();
      }
    }
    if (this.map && this.otherOptions.reloadAllTimeLayers) {
      this.reloadAllTimeLayers();
    }
    if (this.map && this.otherOptions.addInverseMask) {
      this.serviceMap.removeAndAddInverseMask(
        this,
        this.otherOptions.inverseData
      );
    }
    if (this.map && this.otherOptions.renderCatchmentsLayer) {
      this.serviceMap.removeAndAddCatchmentsLayers(
        this,
        this.otherOptions.catchmentInfo
      );
    }
    if (this.basinGeoJSONData) {
      this.createMultiPolygon(this.basinGeoJSONData);
    }
    if (change.giscolorsdata && change.giscolorsdata.currentValue) {
      // this.removeAllLayers();
      this.addBaseLayers(this.layerList);
    }
    if (change.colorsData && change.colorsData.currentValue) {
      // this.removeAllLayers();
      this.addBaseLayers(this.layerList);
    }
    if (change.legenddata && change.legenddata.currentValue) {
      if (this.deviceInfo["deviceType"] === "desktop") {
        this.addLegend();
      }
      // this.addLegend();
    }
    if (change.sourceSelected && change.sourceSelected.currentValue) {
      this.changeAttribution();
    }
    if (change.sourceSelected) {
      // this.closeBottomBar("");
    }
    // if(change.layerList && change.layerList.currentValue){
    //   this.labelStrings = [];
    //   this.removeAllTimeLayers();
    //   this.serviceMap.addTimeBasedLayers(this, this.layerList);
    // }
    if (change.districtList && !change.districtList.isFirstChange()) {
      this.districtList = change.districtList.currentValue.data;
    }
    // this.utils.getStateClicked().subscribe(value=>{
    //   if(value){
    //     console.log("in gis map comp ",value);
    //     this.stateSelect.name= (value.State_Name)
    //   }
    // })
  }

  private createPanes() {
    MapConstants.PANE_LIST.forEach((pane) => {
      this.map.createPane(pane.name);
      this.map.getPane(pane.name).style.zIndex = pane.zindex;
    });
  }

  private initMap(): void {
    this.map = L.map(
      "map",
      this.mapService.getMapOptions(this.STATENAME, ProjConstants)
    );
    this.map.attributionControl.setPrefix(false);
    if (this.utils.getDeviceType() != "desktop") {
      this.map.setView(ProjConstants[this.STATENAME + "_CENTER"], 5);
    }
    this.injectService();
    this.addZoomBar();
    this.createPanes();
    if (this.deviceInfo["deviceType"] === "desktop") {
      this.addLegend();
    }
    // this.utils.setGisMapComp(this);
    // this.addLegend();
    this.addMapEvents();
    this.setUrlParams();
  }

  setInitial() {
    const district = {
      locType: "State",
      loc: this.STATENAME,
      centroid: ProjConstants[this.STATENAME + "_CENTER"],
      zoomLevel: ProjConstants[this.STATENAME + "_ZOOM_LEVEL"],
    };
    this.utils.districtClicked.next(district);
  }

  geoJSONformatData(data) {
    let geodata: any = {
      "type": "FeatureCollection",
      features: []
    }
    for (let i in data) {
      let formatData = {
        "type": "Feature",
        "id": data[i].latitude + '_' + data[i].longitude,
        "geometry": {
          "type": "Point",
          "coordinates": [data[i].longitude, data[i].latitude]
        },
        "geometry_name": "geom",
        "properties": data[i]
      }
      this.metadata[data[i].latitude + '_' + data[i].longitude] = data[i];
      geodata.features.push(formatData);
    }
    return geodata;
  }

  async fetchData() {
    this.finalArray = await new Promise((resolve, reject) => {
      this.http.get('http://103.251.184.43/json/new_lightning_file.php')
        .subscribe(data => {
          let arr = data['lightning_data']['5min_record'];
          let arr1 = data['lightning_data']['10min_record'];
          let arr2 = data['lightning_data']['15min_record'];
          let finalArray = arr.concat(arr1);
          finalArray = finalArray.concat(arr2);
          resolve(finalArray)
        }, (error: any) => {
          this.toastr.error("Backend is not giving response")
          resolve([]);
        })
    })
  }

  async addThunderBoltMarkers() {
     await this.fetchData();
    // const iSize = [20, 20];
    // this.TLayerGrp = new (L as any).layerGroup();

    // let markerData: [] = await new Promise(resolve => {
    //   this.lightningMapService.getLightningMarkersData().subscribe(data => {
    //     resolve(data)
    //   })
    // })
    // console.log("markerDummyData", markerData);

    // markerData.forEach(element => {
    //   let diffTimeInMinutes = diff_minutes(new Date(element['Date'] + " " + element['Time']),new Date())
    //   let color = '';
    //   if(diffTimeInMinutes > 0 && diffTimeInMinutes <= 15)
    //     color = 'red'
    //   else if(diffTimeInMinutes > 15 && diffTimeInMinutes <= 30)
    //     color = 'orange'
    //   else if(diffTimeInMinutes > 30)
    //     color = 'yellow'

    //   let charge = element['Amps'] > 0 ? "+" : "-"
    //   let strikes = element['Strike']

    //   const icon = L.divIcon({
    //     html: '<style> @keyframes animate {0% {opacity: 0; } 50% {opacity: 1.0; } 100% {opacity: 0; } } </style> <div style="transform:scale(0.6) translateX(-10px) translateY(-25px)"> <div style="animation: animate 0.0s linear infinite; color:' + color + ';text-shadow: 2px 2px rgb(0, 0, 0); text-align: center; width: 40px; height: 40px; border-radius: 100%; display: inline-block; font-size: 70px; font-weight:bold; line-height: 0.74; vertical-align:middle;  text-decoration: none">' + charge + '</div> <div style="background-image:radial-gradient(#dddddd,#dddddd,rgba(221,221,221,0.3),rgba(225,225,225,0));text-align: center; width: 30px; height: 30px; border-radius: 100%; display: inline-block; font-size: 20px; font-weight:bold;line-height: 1.4; vertical-align:middle; color:black; text-decoration: none;position:fixed;top:-10px; right: -35px;">' + strikes + '</div> </div>',
    //     iconSize: iSize,
    //     className: ''
    //   });
    //   let colorIcon = icon;
    //   let singleMarker = L.marker(L.latLng(element['Latitude'], element['Longitude']), {
    //     pane: 'mark',
    //     icon: colorIcon,
    //     minZoom: 8
    //   });
    //   singleMarker.on("click", testFunction, this)
    //   this.TLayerGrp.addLayer(singleMarker);

    // });
    let data = this.geoJSONformatData(this.finalArray);
    let geojsonLayer: any = new L.GeoJSON(data, {
      pointToLayer: (feature, layer) => {
        return this.thunderPointToLayer(feature,this.map)
      }
    })
    this.map.addLayer(geojsonLayer);

    // dummyData.forEach(loc => {
    //   let color = loc.color;
    //   let charge = loc.charge
    //   let strikes = loc.strikes

    //   const icon = new L.Icon({
    //     iconUrl:'assets/imgs/thunder_plus.svg',
    //     // html: '<style> @keyframes animate {0% {opacity: 0; } 50% {opacity: 1.0; } 100% {opacity: 0; } } </style> <div style="transform:scale(0.6) translateX(-10px) translateY(-25px)"> <div style="animation: animate 0.0s linear infinite; color:' + color + ';text-shadow: 2px 2px rgb(0, 0, 0); text-align: center; width: 40px; height: 40px; border-radius: 100%; display: inline-block; font-size: 70px; font-weight:bold; line-height: 0.74; vertical-align:middle;  text-decoration: none">' + charge + '</div> <div style="background-image:radial-gradient(#dddddd,#dddddd,rgba(221,221,221,0.3),rgba(225,225,225,0));text-align: center; width: 30px; height: 30px; border-radius: 100%; display: inline-block; font-size: 20px; font-weight:bold;line-height: 1.4; vertical-align:middle; color:black; text-decoration: none;position:fixed;top:-10px; right: -35px;">' + strikes + '</div> </div>',
    //     iconSize: iSize,
    //     className: ''
    //   });
    //   let string_text = "<html><body>";
    //   string_text += "<table class='table table-text-sm table-bordered'>";
    //    string_text += "<tr>" +
    //   "<td>" + loc.lat + "</td>" +
    //   "<td>" + loc.long + "</td>" +
    //   "<td>" + loc.lightningType + "</td>" +
    //   "<td>" + loc.date + "</td>" +
    //   "<td>" + loc.strikes + "</td>" +
    //   "<td>" + loc.charge + "</td>" +
    //   "</tr>";
    //   string_text+= "</table></body></html>";
    //   let colorIcon = icon;
    //   let singleMarker = L.marker(L.latLng(loc.lat, loc.long), {
    //     pane: 'mark',
    //     icon: colorIcon,
    //     minZoom: 8
    //   });
    //   singleMarker.on("click", testFunction, this)
    //   this.TLayerGrp.addLayer(singleMarker);
    // })
    // this.map.addLayer(this.TLayerGrp);

    // var popupOptionsHover = {
    //   minWidth: 350,
    //   autoPan: false
    // };

    // singleMarker.on('click')

    // function testFunction(e) {
    //   let value = {}
    //   dummyData.forEach(ele => {
    //     if (e.latlng.lat == ele.lat) {
    //       value = ele
    //     }
    //   })
    //   if (value != {}) {
    //     this.utils.setLightningDetails(value);
    //     if (!this.dataTabToggleVal)
    //       this.dataTabToggle(true)
    //   }
    // }

    // function diff_minutes(dt2, dt1) {

    //   var diff = (dt2.getTime() - dt1.getTime()) / 1000;
    //   diff /= 60;
    //   return Math.abs(Math.round(diff));

    // }
  }

  thunderPointToLayer(feature,map) {
    let concentricCircleLayer = new L.LayerGroup();
    let latLng: [number, number];
    let iconSize = [25, 25];
    latLng = [feature.geometry.coordinates[1], feature.geometry.coordinates[0]];
    let data: any = this.metadata[latLng[0] + '_' + latLng[1]];
    const currentDate = new Date();
    let currentTime = this.datepipe.transform(currentDate, 'HH:mm:ss');
    let time = data.time.split(" ");
    let svgIcon:any;
    let timeDifference = this.calculateTimeDifference(time[1],currentTime);
    let minutes = timeDifference['minutes'];
    let hours = timeDifference['hours']
    if (Number(data.peak_current) > 0) {
      if(hours !=0 || minutes > 30){
        svgIcon = new L.Icon({
          iconUrl: 'assets/imgs/thunder_plus_yellow.svg',
          iconSize: iconSize,
          iconAnchor: [4, 4],
          popupAnchor: [-5, -5],
        });
      }
      else if(hours ==0 && minutes <= 15) {
        svgIcon = new L.Icon({
          iconUrl: 'assets/imgs/thunder_plus_red.svg',
          iconSize: iconSize,
          iconAnchor: [4, 4],
          popupAnchor: [-5, -5],
        });
      }
      else if((hours ==0 && minutes > 15) && (hours ==0 && minutes <= 30)) {
        svgIcon = new L.Icon({
          iconUrl: 'assets/imgs/thunder_plus_orange.svg',
          iconSize: iconSize,
          iconAnchor: [4, 4],
          popupAnchor: [-5, -5],
        });
      }
    }
    else {
      if(hours !=0 || minutes > 30){
        svgIcon = new L.Icon({
          iconUrl: 'assets/imgs/thunder_minus_yellow.svg',
          iconSize: iconSize,
          iconAnchor: [4, 4],
          popupAnchor: [-5, -5],
        });
      }
      else if(hours ==0 && minutes <= 15) {
        svgIcon = new L.Icon({
          iconUrl: 'assets/imgs/thunder_minus_red.svg',
          iconSize: iconSize,
          iconAnchor: [4, 4],
          popupAnchor: [-5, -5],
        });
      }
      else if((hours ==0 && minutes > 15) && (hours ==0 && minutes <= 30)) {
        svgIcon = new L.Icon({
          iconUrl: 'assets/imgs/thunder_minus_orange.svg',
          iconSize: iconSize,
          iconAnchor: [4, 4],
          popupAnchor: [-5, -5],
        });
      }
    }
    let marker = L.marker(latLng, { icon: svgIcon, pane: 'marker' });
    concentricCircleLayer.addLayer(marker);
    var htmlString = "<html><body>";
    htmlString += '<div class="popup-table-section">';
    htmlString += `<div class="card-body p-0">
       <table class="table table-sm m-0 table-bordered">`;
    htmlString += `<tbody>
       <tr>
         <th class="text-light">Latitude</th>
         <td class="text-light">${data.latitude}</td>
       </tr>
       <tr>
         <th class="text-light">Longitude</th>
         <td class="text-light">${data.longitude}</td>
       </tr>
       <tr>
       <th class="text-light">Date & Time</th>
       <td class="text-light">${data.time}</td>
     </tr>
     <tr>
     <th class="text-light">Flash Type</th>
     <td class="text-light">${data.flash_type == 0 ? 'Cloud to Ground' : 'Cloud to Cloud'}</td>
   </tr>
       <tr>
         <th class="text-light">Peak Current</th>
         <td class="text-light">${this.getFormattedNumber(data.peak_current)} KA</td>
       </tr>
       <tr>
       <th class="text-light">IC Height</th>
       <td class="text-light">${Number(data.ic_height)} m</td>
     </tr>
     </table>
   </div>
   </div>`;
    marker.on({
      click: (e: any) => {
        var popup = L.popup()
          .setLatLng(e.latlng)
          .setContent(htmlString)
          .openOn(map);
      }
    })
    return concentricCircleLayer;

  }

  getFormattedNumber(number:any) {
    let num :any= Number(number);
    num = num > 0 ? num.toString().slice(0,2) : num.toString().slice(0,3);
    return num
  }

   calculateTimeDifference(start: string, end: string): { hours: number, minutes: number } {
    const startTime = new Date();
    const endTime = new Date();

    const startParts = start.split(':');
    startTime.setHours(parseInt(startParts[0], 10));
    startTime.setMinutes(parseInt(startParts[1], 10));
    startTime.setSeconds(parseInt(startParts[2], 10));

    const endParts = end.split(':');
    endTime.setHours(parseInt(endParts[0], 10));
    endTime.setMinutes(parseInt(endParts[1], 10));
    endTime.setSeconds(parseInt(endParts[2], 10));

    const timeDifference = endTime.getTime() - startTime.getTime();
    const hours = Math.floor(timeDifference / (1000 * 60 * 60));
    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));

    return { hours, minutes };
  }

  addMarkers() {
    const iSize = [15, 15];
    const namePopup = new L.popup({
      closeButton: false,
      autoClose: false,
    });
    let customPopup = "";
    const normalIcon = L.icon({
      iconUrl: "/assets/imgs/mapMark_G.svg",
      iconSize: iSize,
      interactive: true,
    });
    const sufficientSupplyIcon = L.icon({
      iconUrl: "/assets/imgs/mapMark_B.svg",
      iconSize: iSize,
      interactive: true,
    });
    const criticalIcon = L.icon({
      iconUrl: "/assets/imgs/mapMark_R.svg",
      iconSize: iSize,
      interactive: false,
    });
    const moderateIcon = L.icon({
      iconUrl: "/assets/imgs/mapMark_O.svg",
      iconSize: iSize,
      interactive: true,
    });
    const noIcon = L.icon({
      iconUrl: "/assets/imgs/mapMark_NA.svg",
      iconSize: iSize,
      interactive: true,
    });
    const moderateSupplyIcon = L.icon({
      iconUrl: "/assets/imgs/mapMark_NA.svg",
      iconSize: iSize,
      interactive: true,
    });
    this.MLayerGrp = new (L as any).layerGroup();
    let singleMarker;
    let colorIcon = normalIcon;
    if (this.rUview == "Urban" && this.ulbData) {
      for (let i = 0; i < this.ulbData.length; i++) {
        if (this.ulbData[i]["stress"] == ProjConstants.SYSTEM_CRITICAL_STRESS) {
          colorIcon = criticalIcon;
        } else if (
          this.ulbData[i]["stress"] == ProjConstants.SYSTEM_MODERATE_STRESS
        ) {
          colorIcon = moderateIcon;
        } else if (
          this.ulbData[i]["stress"] == ProjConstants.SYSTEM_NORMAL_STRESS
        ) {
          colorIcon = normalIcon;
        } else if (
          this.ulbData[i]["stress"] == ProjConstants.MODERATE_WATER_SUPPLY
        ) {
          colorIcon = moderateSupplyIcon;
        } else if (
          this.ulbData[i]["stress"] == ProjConstants.SUFFICIENT_WATER_SUPPLY
        ) {
          colorIcon = sufficientSupplyIcon;
        } else {
          colorIcon = noIcon;
        }

        singleMarker = L.marker([this.ulbData[i].lat, this.ulbData[i].lon], {
          pane: "mark",
          icon: colorIcon,
          minZoom: 8,
        });
        singleMarker.on("click", this.markerClickEvent, this);
        customPopup =
          "<style> .leaflet-tooltip {padding: 8px;background-color:#ffffff;border: 0px solid #000;border-radius: 4px;color: #00000; white-space: nowrap;user-select: none;pointer-events: none;box-shadow: 0 1px 3px rgba(0,0,0,1);}</style><h6>" +
          this.ulbData[i]["ulbName"][0].toUpperCase() +
          this.ulbData[i]["ulbName"].substring(1).toLowerCase() +
          "</h6>";
        singleMarker.bindTooltip(customPopup, {
          interactive: true,
          offset: [-10, 0],
          class: ".leaflet-tooltip",
          direction: "left",
          className: "myPopup",
          pane: "popup",
        });
        // singleMarker.bindLabel('Lable is working')
        this.MLayerGrp.addLayer(singleMarker);
      }
      this.map.addLayer(this.MLayerGrp);
    }
  }

  markerClickEvent(e) {
    this.isUlbMarkerClicked = true;
    const propArray = [];
    this.ulbData.forEach((element) => {
      propArray.push(element);
      if (e.latlng.lat == element.lat && e.latlng.lng == element.lon) {
        const modalRef = this.modalService.open(InfomodalComponent, {
          backdrop: "static",
          keyboard: true,
          windowClass: "backgroundTransparent  infocomponentDWS",
        });
        modalRef.componentInstance.ulbInfo = element;
        modalRef.componentInstance.selected = "ULB Info";
        // this.utils.setULBselected(element);
        this.selectedLocation = element.ulbName;
        console.log("ulb Clicked", this.selectedLocation);
        // this.addUrbanBodieLayers(this.layerList, element['locUUID'],true);
        // this.loadAllUrbanBodiesLayers()
      }
    });
    // this.map.setView([e.latlng.lat, e.latlng.lng], 12);
    // this.map.removeLayer(this.MLayerGrp);
  }

  public setUrlParams() {
    if (this.otherOptions["urlParams"]) {
      this.urlParams = this.otherOptions["urlParams"];
    }
  }

  public injectService() {
    this.serviceMap = this.injector.get<any>(this.otherOptions["service"]);
  }

  public addMapEvents() {
    this.map.on({
      zoomstart: () => {
        {
          if (
            this.clickedLocationMarker != null &&
            this.clickedLocationMarker != undefined
          ) {
            this.clickedLocationMarker.unbindTooltip();
            this.clickedLocationMarker.bindTooltip(this.clickedLocationTooltip);
            this.clickedLocationMarker = null;
          }
        }
      },
      zoomend: () => {
        this.addAllUlbs();
        if (
          (this.rUview == "Urban" &&
            this.map.getZoom() > 9 &&
            !isNullOrUndefined(this.MLayerGrp)) ||
          (this.rUview == "Rural" && !isNullOrUndefined(this.MLayerGrp))
        ) {
          this.map.removeLayer(this.MLayerGrp);
        } else {
          this.selectedLocation = "";
          this.map.removeLayer(this.ulbNameLayer);
          this.isUlbMarkerClicked = false;
          // this.map.addLayer(this.MLayerGrp);
          const ulbhide = {
            show: false,
          };
          // this.utils.setULBLayer(ulbhide);
        }
        // console.log(this.map.getZoom())
      },
    });
  }

  addSubscriptions() {
    // this.rUview = 'Rural'
    this.forecastLengthSubscription = this.route.params.subscribe(
      (routeParams) => {
        this.utils.setCurrentPlayPosition(null);
        this.utils.thresholdMap.next({});
        this.changeLayerStyleforThreshold("");
        const forecastLength = routeParams.time;
        if (forecastLength != this.forecastLength) {
          this.forecastLength = routeParams.time;
          this.playButtonDisable = true;
          this.labelStrings = [];
          if(this.selectedComponent == 'heatwatches') {
            this.blockNumber = this.heatIndexDataService.setBlockNumber();
          } else {
            this.blockNumber = 0;
          }
          this.removeAllTimeLayers();
          if (this.selectedComponent !== "drinkingwaterstress") {
            this.serviceMap.addTimeBasedLayers(this, this.layerList);
          }
          if (this.deviceInfo["deviceType"] === "desktop") {
            this.addLegend();
          }
          // this.addLegend();
        }
      }
    );

    this.utils.meanMedian.subscribe((value) => {
      this.meanMedian = value;
    });

    this.utils.setHeatWaveSource.subscribe((value) => {
      if(this.selectedComponent == 'heatwatches') {
        this.blockNumber = this.heatIndexDataService.setBlockNumber();
        // this.showThrobber = true
      }
    });

    this.utils.minMax.subscribe((value) => {
      if (value != this.minMax) {
        this.minMax = value;
        this.playButtonDisable = true;
        this.labelStrings = [];
        this.removeAllTimeLayers();
        if (this.selectedComponent !== "drinkingwaterstress") {
          this.serviceMap.addTimeBasedLayers(this, this.layerList);
        }
      }
    });
    // this.DWSDataService.getLocForMapUrbanFromGeo().subscribe(data =>
    //   {
    //     this.ulbData = data['features']
    //     this.RUEnabled = true;
    //   })
    if (this.router.url.split("/")[1] == "lightning") {
      this.adminBasinSubscription = this.utils
        .getAdminBasinToggle()
        .subscribe((value) => {
          // 15.075258, 78.678603
          setTimeout(() => {
            this.addThunderBoltMarkers();
          }, 500);
        });
    }
    if (this.router.url.split("/")[1] == "drinkingwaterstress") {
      this.ruralUrbanSubscription = this.utils
        .getRuralUrbanToggle()
        .subscribe((value) => {
          if (this.ruralUrbanSelected != value) {
            this.ruralUrbanSelected = value;
            if (this.ruralUrbanSelected == true) {
              this.rUview = "Rural";
            } else {
              this.getUlbLocData();
              this.rUview = "Urban";
            }
            this.removeAllLayers();
            setTimeout(() => {
              this.addBaseLayers(this.layerList);
              this.addMarkers();
              this.loadAllUrbanBodiesLayers();
            }, 500);
          }
        });
    }
    this.adminBasinSubscription = this.utils
      .getAdminBasinToggle()
      .subscribe((value) => {
        if (this.adminSelected != value) {
          this.adminSelected = value;
          if (this.adminSelected == true) {
            this.view = "Admin";
          } else {
            this.view = "Basin";
          }
          this.removeAllLayers();
          this.addBaseLayers(this.layerList);
          if (this.selectedComponent !== "drinkingwaterstress") {
            this.serviceMap.addTimeBasedLayers(this, this.layerList);
          }
        }
      });
    // this.utils.districtClicked.subscribe(() => {
    //   this.removeAllLayers();
    //   this.addBaseLayers(this.layerList);
    //   this.serviceMap.addTimeBasedLayers(this, this.layerList);
    // });
    this.utils.getQueryParamsDrought().subscribe((value) => {
      if (value && Object.keys(value).length > 0) {
        console.log(this.dataTabToggleVal);
        if (value["maponclick"] && !this.dataTabToggleVal) {
          this.dataTabToggle(null);
        } else if (!value["maponclick"] && this.dataTabToggleVal) {
          this.dataTabToggle(true);
        }
      }
    });
    this.leftSideBarSubscription = this.utils.index.subscribe((value) => {
      if (value != null && value != undefined) {
        this.serviceMap.changeTimeLayers(this, value);
      }
    });

    this.UrbanLayerSubscription = this.utils
      .getULBLayer()
      .subscribe((value) => {
        if (value) {
          if (
            !isNullOrUndefined(this.ulbLayer) &&
            this.map.hasLayer(this.ulbLayer["layer"])
          ) {
            this.map.removeLayer(this.ulbLayer["layer"]);
          }
          if (value["show"] == true && value["showSingleUlb"] == false) {
            // this.addUrbanBodieLayers(this.layerList, value['p_uuid'], false);
            // this.loadAllUrbanBodiesLayers()
          } else if (value["show"] == true && value["showSingleUlb"] == true) {
            // this.addUrbanBodieLayers(this.layerList, value['p_uuid'], true);
            // this.loadAllUrbanBodiesLayers()
          }
        }
      });

    this.villageLayerSubscription = this.utils
      .getvillageLayer()
      .subscribe((value) => {
        if (value) {
          if (value["show"] == true) {
            this.addVillageBaseLayers(this.layerList, value["p_uuid"]);
          } else {
            if (
              !isNullOrUndefined(this.villageLayer) &&
              this.map.hasLayer(this.villageLayer["layer"])
            ) {
              this.map.removeLayer(this.villageLayer["layer"]);
              this.map.removeLayer(this.villageWMSLayer["layer"]);
            }
          }
        }
      });

    this.districtClickedSubscription = this.utils.districtClicked.subscribe(
      (value) => {
        if (value) {
          this.districtClicked = value;
        }
        let blockLayer = null;
        // for (const i in this.activeLayers) {
        //   const layer = this.activeLayers[i];
        //   if (layer['name'] != undefined && layer['name'] != null && layer['name'] == 'blockLayer') {
        //     blockLayer = layer['layer'];
        //   }
        // }
        // if (this.districtClicked == null) {
        //   if (this.map.getZoom() < 9) {
        //     this.map.removeLayer(blockLayer);
        //     blockLayer.options.minZoom = 9;
        //     blockLayer.addTo(this.map);
        //   }
        //   return;
        // }
        if (this.districtClicked["loc"] == undefined) {
          return;
        }
        let latLong: any;
        let zoomLevel: any;
        let StateUUID: any;
        let centroid: any;
        let state: any;
        let values: any;
        // console.log("district clicked", this.districtClicked)
        if (this.districtClicked["locType"] == "State") {
          latLong = this.districtClicked["centroid"];
          zoomLevel = this.districtClicked["zoomLevel"];
          centroid = this.districtClicked["centroid"];
          this.locType = 'State'
          // if (this.map.getZoom() < 9) {
          //   if (this.map.hasLayer(blockLayer)) {
          //     this.map.removeLayer(blockLayer);
          //   }
          //   if (!isNullOrUndefined(blockLayer)) {
          //     blockLayer.options.minZoom = 9;
          //     blockLayer.addTo(this.map);
          //   }
          // }
          this.map.setView(latLong, zoomLevel);
        }
        if (this.districtClicked["locType"] == "Country") {
          latLong = this.districtClicked["centroid"];
          zoomLevel = this.districtClicked["zoomLevel"];
          this.locType = 'Country'
          // if (this.map.getZoom() < 9) {
          //   if (this.map.hasLayer(blockLayer)) {
          //     this.map.removeLayer(blockLayer);
          //   }
          //   if (!isNullOrUndefined(blockLayer)) {
          //     blockLayer.options.minZoom = 9;
          //     blockLayer.addTo(this.map);
          //   }
          // }
          this.showD2 = false;
          this.map.setView(latLong, zoomLevel);
        } else if (this.adminSelected || this.ruralUrbanSelected) {
          // latLong = MapConstants[ProjConstants.STATENAME+'_DISTRICT_CENTERS'][this.districtClicked['loc'].toUpperCase()]
          latLong = [
            this.districtClicked["centroid"]["lat"],
            this.districtClicked["centroid"]["lon"],
          ];
          zoomLevel = 10;
          if (
            ProjConstants.LOC_ZOOM_LEVEL[this.districtClicked["locType"]] !=
            undefined
          ) {
            zoomLevel =
              ProjConstants.LOC_ZOOM_LEVEL[this.districtClicked["locType"]];
          }
        } else {
          // latLong = MapConstants[ProjConstants.STATENAME+'_BASIN_CENTERS'][this.districtClicked['loc'].toUpperCase()][0]
          latLong = [
            this.districtClicked["centroid"]["lat"],
            this.districtClicked["centroid"]["lon"],
          ];
          zoomLevel = 9;
          if (
            ProjConstants.LOC_ZOOM_LEVEL[this.districtClicked["locType"]] !=
            undefined
          ) {
            zoomLevel =
              ProjConstants.LOC_ZOOM_LEVEL[this.districtClicked["locType"]];
          }
          if (
            this.districtClicked["locType"] == "Basin" &&
            MapConstants[ProjConstants.STATENAME + "_BASIN_CENTERS"][
              this.districtClicked["loc"].toUpperCase()
            ] != undefined
          ) {
            zoomLevel =
              MapConstants[ProjConstants.STATENAME + "_BASIN_CENTERS"][
                this.districtClicked["loc"].toUpperCase()
              ][1];
          }
          blockLayer.options.minZoom = zoomLevel;
          this.map.removeLayer(blockLayer);
          blockLayer.addTo(this.map);
        }
        if (this.districtClicked["locType"] == "ULB") {
          this.map.flyTo(latLong, zoomLevel);
        } else {
          this.map.setView(latLong, zoomLevel);
        }
        if (this.selectedComponent === 'rainfallActual' || !isEmptyObject(value)) {
          this.utils.onLocationChange.next(true);

        }
      }
    );
    // this.stateSubscription = this.utils.stateClicked.subscribe(value=>{
    //   this.stateClicked = value;
    //   let latLong,zoomLevel
    //   latLong = [this.stateClicked['centroid']['lat'], this.stateClicked['centroid']['lon']];
    //   zoomLevel = 7
    //   this.map.setView(latLong, zoomLevel)

    // })
    // this.countrySubscription = this.utils.countryClicked.subscribe(value=>{
    //   this.countryClicked = value;
    //   let latLong,zoomLevel
    //   latLong = [this.countryClicked['centroid']['lat'], this.countryClicked['centroid']['lon']];
    //   zoomLevel = 5
    //   this.map.setView(latLong, zoomLevel)

    // })
    this.utilService.getRadarSourceData().subscribe( source => {
      if(this.selectedComponent == "nowcastweather") {
        this.showThrobber = true
        if(source != 'RICKEN') {
          this.blockNumber = 5
        } else {
          this.blockNumber = 0
        }
        this.playFastSlow = true
      setTimeout(() => {
        this.serviceMap.addTimeBasedLayers(this, this.layerList);
      },5000)
    }
});
    this.utilService.getNowcastView().subscribe(view => {
      if(this.selectedComponent == "nowcastweather" && view) {
        this.nowcastView = view;
        this.showThrobber = true
        this.removeAllLayers();
        this.addBaseLayersForNowcast(this.layerList,view)
        setTimeout(() => {
          this.serviceMap.addTimeBasedLayers(this, this.layerList);
        },5000)
      }
    })
  }

  addLegend() {
    this.showLegand = !this.showLegand;
    let data = this.legenddata ? this.legenddata : this.otherOptions.legend;
    if (this.forecastLength === "weekly") {
      data = this.otherOptions.weeklyLegend;
    }
    // function for legend styling
    if (this.showLegand) {
      this.legend.remove();
    }
    if(this.application == 'extremeweather' || this.selectedComponentType == 'seamless-view' || this.selectedComponentType == 'rainfall-actual'|| this.application == 'rainfallActual') {
      this.showLegand = false
    }
    const legend = L.control({ position: "bottomright" });
    if (this.showLegand == false) {
      legend.onAdd = () => {
        const div = L.DomUtil.create("div", "info");
        div.style = "max-height: 500px; overflow-y: auto;";
        if (data != null && data != undefined) {
          if (data.Units != undefined && data.Units != null) {
            div.innerHTML +=
              '<p class="bg-white font-weight-bold text-dark text-center my-0">' +
              data.Units +
              "</p";
          }
          const ranges = data.colorValues;
          for (let i = ranges.length - 1; i >= 0; i--) {
            div.innerHTML +=
              '<p class="my-0 font-weight-bold text-center" style="background-color:' +
              ranges[i]["backgroundColor"] +
              " ; color:" +
              ranges[i]["color"] +
              '"><span style="postition = absolute; padding:0,20px;">' +
              ranges[i].text +
              "</span></p>";
          }
        }
        return div;
      };
      this.legend = legend;
      legend.addTo(this.map);
    }
  }

  addBaseLayers(layerList) {
    for (const index in layerList) {
      const layer = layerList[index];
      if (
        layer["type"] == "Base" &&
        (layer["view"] == this.view || layer["view"] == "Both")
      ) {
        const layerObj = this.serviceMap.createLayer(layer, this);
        if (layerObj["layer"] != undefined && layerObj["layer"] != null) {
          layer["hidelayer"] == true
            ? layer["hidelayer"] == false || !layer["hidelayer"]
            : layerObj["layer"].addTo(this.map);
          this.activeLayers = this.activeLayers.concat(layerObj);
        }
        layerList[index] = layerObj;
        // console.log("layerObj",layerObj);

        if (
          this.giscolorsdata &&
          (layerObj.layerName == "ANDHRA PRADESH_STATE_BLOCK" ||
            layerObj.layerName == "HEATWAVE:ALL_INDIA_BLOCKS" ||
            layerObj.serviceType == "VectorLayer")
        ) {
          // console.log("called inside gis Map Comp")
          this.serviceMap.fillMapWithColors(this.giscolorsdata, layerObj); // coloring for drought
        }
        if (
          this.gistest &&
          layerObj.layerName == "ANDHRA PRADESH_STATE_BLOCK" &&
          this.rUview == "Rural"
        ) {
          this.serviceMap.fillMapColorForDWStress(
            this.colorsData,
            layerObj,
            this
          );
        }
      }
    }

    this.layerList = layerList;
    console.log("layerlist check",this.layerList);
  }

  addBaseLayersForNowcast(layerList,view) {
    for (const index in layerList) {
      const layer = layerList[index];
      if (
        layer["type"] == "Base" &&
        (layer['nowcastView'] == view)
      ) {
        const layerObj = this.serviceMap.createLayer(layer, this);
        if (layerObj["layer"] != undefined && layerObj["layer"] != null) {
          layer["hidelayer"] == true
            ? layer["hidelayer"] == false || !layer["hidelayer"]
            : layerObj["layer"].addTo(this.map);
          this.activeLayers = this.activeLayers.concat(layerObj);
        }
        layerList[index] = layerObj;
        // console.log("layerObj",layerObj);

        if (
          this.giscolorsdata &&
          (layerObj.layerName == "ANDHRA PRADESH_STATE_BLOCK" ||
            layerObj.layerName == "HEATWAVE:ALL_INDIA_BLOCKS" ||
            layerObj.serviceType == "VectorLayer")
        ) {
          // console.log("called inside gis Map Comp")
          this.serviceMap.fillMapWithColors(this.giscolorsdata, layerObj); // coloring for drought
        }
        if (
          this.gistest &&
          layerObj.layerName == "ANDHRA PRADESH_STATE_BLOCK" &&
          this.rUview == "Rural"
        ) {
          this.serviceMap.fillMapColorForDWStress(
            this.colorsData,
            layerObj,
            this
          );
        }
      }
    }
    this.layerList = layerList;
  }

  loadAllUrbanBodiesLayers() {
    const tempUlbData = this.ulbData;
    const ULBs = {
      layerNameType: "AP_ULB",
      layerName: "AP_ULB",
      serviceType: "VectorLayer",
      view: "Admin",
      type: "Base",
      name: "ULBLayer",
      maxZoom: 10,
      visible: true,
    };
    this.allUlbLayer = this.serviceMap.createVectorLayer(ULBs, this)["layer"];
    // console.log('allULBLayer',this.allUlbLayer)
    const style = {
      color: "rgb(0, 0, 0)",
      fill: true,
      fillColor: "blue",
      fillOpacity: 100,
      opacity: 1,
      weight: 1.5,
    };
    this.allUlbLayer.options.vectorTileLayerStyles["AP_ULB"] = function (
      properties,
      zoom
    ) {
      tempUlbData.forEach((e) => {
        if (e["ulbUUID"] == properties.uuid) {
          if (e["stress"] == ProjConstants.SYSTEM_CRITICAL_STRESS) {
            style["fillColor"] = "#eb5d53";
          } else if (e["stress"] == ProjConstants.SYSTEM_MODERATE_STRESS) {
            style["fillColor"] = "#f3bc5c";
          } else if (e["stress"] == ProjConstants.SYSTEM_NORMAL_STRESS) {
            style["fillColor"] = "#59a74e";
          } else if (e["stress"] == ProjConstants.SUFFICIENT_WATER_SUPPLY) {
            style["fillColor"] = "#074fbf";
          } else if (e["stress"] == ProjConstants.MODERATE_WATER_SUPPLY) {
            style["fillColor"] = "#42b4e6";
          } else {
            style["fillColor"] = "#7f7f7f";
          }
        }
      });
      // style ={
      //   color: "rgb(0, 0, 0)",
      //   fill:true,
      //   fillColor:'red',
      //   opacity: 1,
      //   weight:1.5
      // }
      // return style;
      return style;
    };
    // this.isallUlbsAdded = true;

    let titleMarker;
    this.ulbData.forEach((element) => {
      titleMarker = L.marker([element.lat, element.lon], {
        icon: L.divIcon({
          className: "",
          html:
            "<div style='text-align:center; position:absolute; transform: translate(-" +
            Math.floor(element["ulbName"].split(" ")[0].length / 2).toString() +
            "0px" +
            ", 0px);'><p style = 'color:black;background-color:rgba(210,210,210,0); back;position: absolute; padding:3px; border-radius:5px'>" +
            element["ulbName"] +
            "</p></div>",
        }),
        pane: "popUp",
        direction: "left",
        offset: [0, 0],
      });
      this.allUlbNames.addLayer(titleMarker);
    });
    // this.map.addLayer(this.allUlbNames)
    // this.map.addLayer(this.allUlbLayer)
  }

  addAllUlbs() {
    if (this.rUview == "Urban") {
      if (this.map.getZoom() > 9) {
        this.map.addLayer(this.allUlbNames);
        this.map.addLayer(this.allUlbLayer);
      } else {
        if (
          this.map.hasLayer(this.allUlbLayer) &&
          this.map.hasLayer(this.allUlbNames)
        ) {
          this.map.removeLayer(this.allUlbNames);
          this.map.removeLayer(this.allUlbLayer);
        }
      }
    }
  }

  addUrbanBodieLayers(layerList, p_uuid, showSingleUlb) {
    const ULBs = {
      layerNameType: "AP_ULB",
      layerName: "AP_ULB",
      serviceType: "VectorLayer",
      view: "Admin",
      type: "Base",
      name: "ULBLayer",
      minZoom: 5,
      visible: true,
      CQL_FILTER: p_uuid,
    };
    this.ulbLayer = this.serviceMap.createVectorLayer(ULBs, this);
    this.serviceMap.ulbDrawLayers(this.ulbLayer, this, showSingleUlb);
    this.map.addLayer(this.ulbLayer["layer"]);
    // this.map.removeLayer(this.MLayerGrp)

    // Markers are ULB Titles

    let titleMarker: any;
    const classNameee = ".my-div-icon{background-color: red;}";
    this.ulbNameLayer.clearLayers();
    if (!showSingleUlb) {
      this.ulbData.forEach((element) => {
        if (p_uuid == element["distUUID"]) {
          titleMarker = L.marker([element.lat, element.lon], {
            icon: L.divIcon({
              className: classNameee,
              html:
                "<h6 style = 'text-align:center;background-color:rgba(210,210,210,0); back;position: absolute; padding:3px; border-radius:5px'>" +
                element["ulbName"] +
                "</h6>",
            }),
            pane: "popUp",
            direction: "left",
            offset: [0, 0],
          });
          this.ulbNameLayer.addLayer(titleMarker);
        }
      });
    } else {
      this.ulbData.forEach((element) => {
        if (p_uuid == element["distUUID"]) {
          titleMarker = L.marker([element.lat, element.lon], {
            icon: L.divIcon({
              className: classNameee,
              html:
                "<h6 style = 'text-align:center;background-color:rgba(210,210,210,0.8); back;position: absolute; padding:3px; border-radius:5px'>" +
                element["ulbName"] +
                "</h6>",
            }),
            pane: "popUp",
            direction: "left",
            offset: [0, 0],
          });
          this.ulbNameLayer.addLayer(titleMarker);
        }
      });
    }
    this.isUlbMarkerClicked = true;
    this.map.addLayer(this.ulbNameLayer);
  }

  getUlbLocData() {
    this.DWSDataService.getLocCentroidData("ULB").subscribe((data) => {
      if (!isNullOrUndefined(data)) {
        this.ulbCentroidData = data;
        // console.log('ulbCentroidData',this.ulbCentroidData)
      }
    });
  }

  addVillageBaseLayers(layerList, p_uuid) {
    const village = {
      layerNameType: "AP_VILLAGE",
      layerName: "AP_VILLAGE",
      serviceType: "VectorLayer",
      view: "Admin",
      type: "Base",
      name: "villageLayer",
      minZoom: 12,
      visible: true,
      CQL_FILTER: p_uuid,
    };
    const villageWMS = {
      layerNameType: "forecast:AP_VILLAGE",
      layerName: "forecast:AP_VILLAGE",
      serviceType: "WmsLayer",
      view: "Admin",
      type: "Base",
      env: "bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000",
      style: "forecast:block_only_label",
      minZoom: 12,
      cql_filter: "p_uuid IN ('" + p_uuid + "')",
    };
    this.villageWMSLayer = this.serviceMap.createWmsLayer(villageWMS, this);
    this.villageLayer = village;
    this.villageLayer = this.serviceMap.createVectorLayer(village, this);
    this.mapLayerGroup = new (L as any).layerGroup();
    this.utils.getvillageData().subscribe((colorsData) => {
      this.serviceMap.fillMapColorForDWStress(
        colorsData,
        this.villageLayer,
        this,
        this.mapLayerGroup
      );
    });
    this.map.addLayer(this.villageLayer["layer"]);
    this.map.addLayer(this.villageWMSLayer["layer"]);
  }

  addZoomBar() {
    const zoomBarControl = new (L as any).control.zoomBar();
    zoomBarControl.addTo(this.map);
  }

  createLabels() {
    if (this.forecastLength == "24") {
      this.timeStampList = this.utils.get24HrsTimeStamps();
      for (const index in this.timeStampList) {
        if (index == "4") {
          this.labelStrings[index] = { label: "24hr", groupName: "24hr" };
        } else {
          this.labelStrings[index] = {
            label: this.convertTimestampToBlockValue(this.timeStampList[index]),
            groupName: this.timeStampList[index].toString(),
          };
        }
      }
    } else if (this.forecastLength == "10") {
      this.timeStampList = this.utils.get10DaysTimeStamps();
      for (const index in this.timeStampList) {
        this.labelStrings[index] = {
          label: this.convertTimestampToBlockValue(this.timeStampList[index]),
          groupName: this.timeStampList[index].toString(),
        };
      }
    }
  }

  convertTimestampToBlockValue(ts) {
    ts = Number(ts);
    if (this.forecastLength == "24") {
      let hours = new Date(ts).getHours();
      const minutes = new Date(ts).getMinutes();
      let amPm = "A.M";
      if (hours > 12) {
        hours = hours - 12;
        amPm = "P.M";
      }
      return hours.toString() + ":" + minutes.toString() + " " + amPm;
    } else if (this.forecastLength == "10") {
      const date = new Date(ts).toLocaleDateString();
      return date;
    } else {
      return ts;
    }
  }

  show() {}

  revalidateMap(): void {
    window.dispatchEvent(new Event("resize"));
    if (this.map) {
      setTimeout(() => {
        this.map.invalidateSize();
      }, 200);
    }
  }

  dataTabToggle(value?: boolean) {
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 200);
    const data = this.utils.getQueryParamsDroughtValue();
    const moduleName = this.router.url.split("/")[1];
    // console.log(moduleName, data['maponclick'], this.dataTabToggleVal);
    const flag =
      moduleName == ""
        ? data["maponclick"] &&
          (this.dataTabToggleVal || !this.dataTabToggleVal)
          ? true
          : false
        : true;
    if (value || flag) {
      this.revalidateMap();
      this.dataTabToggleVal = !this.dataTabToggleVal;
      this.utils.setCurrentComponent(this.router.url.split("/")[2]);

      if (this.dataTabToggleVal) {
        if (document.getElementById("MapContainer").offsetWidth < 1600) {
          document.documentElement.style.setProperty("--opacite", "none");
          document.documentElement.style.setProperty("--lPercent", "70%");
        }
      } else {
        document.documentElement.style.setProperty("--opacite", "display");
        document.documentElement.style.setProperty("--lPercent", "50%");
      }
    }
  }

  openBottomBar(apiParams, bottomBarComponent) {
    this.bottomBarComponent = bottomBarComponent;
    this.showBottomBar = true;
    this.apiParams = apiParams;
  }

  changeTimeLayers(groupName) {
    this.utils.getRadarSourceData().subscribe(source => {
    if (this.router.url.split("/")[1] === "extremeweather") {
      if (groupName !== "24hr") {
        this.counter = parseInt(groupName, 10);
        this.hourCounter = "";
        if (this.router.url.split("/")[3] === "weekly") {
          this.blockNumber = Math.floor(
            (this.counter - this.initialCounter) / (7 * 86400000)
          );
        } else if (
          (this.router.url.split("/")[2] === "rainfall" ||
            this.router.url.split("/")[2] === "temperature" ||
            this.router.url.split("/")[2] === "humidity") &&
          this.router.url.split("/")[3] === "10"
        ) {
          this.blockNumber = Math.floor(
            (this.counter - this.initialCounter) / 86400000
          );
        }
        else if (this.router.url.split("/")[2] === "windspeed" && this.router.url.split("/")[3] === "10") {
          this.blockNumber = Math.floor(
            // (this.counter - this.initialCounter) / 10800000
            (this.counter - this.initialCounter) / 21600000
          );
        }
        else {
          this.blockNumber = Math.floor(
            (this.counter - this.initialCounter) / 10800000
            // (this.counter - this.initialCounter) / 21600000
          );
        }
      } else {
        this.hourCounter = groupName;
        this.blockNumber = 8;
      }
    } else if (this.router.url.split("/")[1] === "heatwatches") {
      this.blockNumber = this.dateBlockNumMap[parseInt(groupName, 10)];
    } else if (this.router.url.split("/")[1] === "nowcastweather") {
      this.counter = parseInt(groupName, 10);
      // this.blockNumber = Math.floor(
      //   (this.counter - this.initialCounter) / 3600000
      // );

      if (source === 'RICKEN') {
        this.blockNumber = Math.floor(
          (this.counter - this.initialCounter) / 3600000 // 1 hour in milliseconds
        );
      } else if (source) {
        this.blockNumber = Math.floor(
          (this.counter - this.initialCounter) / 600000 // 10 minutes in milliseconds
        );
        // console.log("BLOCKNUMBER::",this.blockNumber);
      }
    }
    if (
      (this.route.snapshot.paramMap.get("time") === "10" ||
        this.route.snapshot.paramMap.get("time") === "weekly") &&
      this.router.url.split("/")[2] === "rainfall" &&
      this.sourceSelected === "ECMWF"
    ) {
      this.utils.setCurrentPlayPosition(groupName);
    }
    this.serviceMap.changeTimeLayers(this, groupName);
    if (
      !isNullOrUndefined(this.thresholdMap) &&
      Object.keys(this.thresholdMap).length > 0
    ) {
      this.changeLayerStyleforThreshold();
    }
  });
  }


  removeGroupTimeLayers(groupName) {
    this.serviceMap.removeGroupTimeLayers(this, groupName);
  }

  removeAllTimeLayers() {
    this.serviceMap.removeAllTimeLayers(this);
  }

  removeAllLayers() {
    for (const index in this.activeLayers) {
      const layer = this.activeLayers[index];
      if (
        layer != undefined &&
        layer["layer"] != undefined &&
        layer["layer"] != null
      ) {
        this.map.removeLayer(layer["layer"]);
      }
      this.activeLayers[index] = "deleted";
    }
    this.activeLayers = this.activeLayers.filter((item) => item != "deleted");
    this.map.eachLayer((layer: any) => this.map.removeLayer(layer));
  }

  closeBottomBar(event) {
    if (this.map.hasLayer(this.clickedLocationMarker)) {
      this.clickedLocationMarker.unbindTooltip();
      this.clickedLocationMarker.bindTooltip(this.clickedLocationTooltip);
      this.clickedLocationMarker = null;
    }
    if (this.map.hasLayer(this.marker)) {
      this.map.removeLayer(this.marker);
      this.marker = null;
    }
    this.showBottomBar = false;
  }

  setLocationData() {
    if (this.utils.getDeviceType() == "mobile") {
      this.utils.getLocationLayerData(
        (data) => {
          this.selectedLocation = data.features[0].properties.block;
        },
        (error) => {
          console.log(error);
          this.selectedLocation =
            ProjConstants.IDTOLOCATIONMAPPING[
              this.route.snapshot.paramMap.get("id")
            ];
        },
        "INDIA_BLOCK"
      );
    } else {
      this.utils.getLocationLayerData(
        (data) => {
          if (
            data.features &&
            data.features.length == 1 &&
            data.features[0].properties &&
            data.features[0].properties.block &&
            data.features[0].properties.state_name == this.STATENAME
          ) {
            this.selectedLocation = data.features[0].properties.block;
          } else {
            this.selectedLocation =
              ProjConstants.IDTOLOCATIONMAPPING[
                this.route.snapshot.paramMap.get("id")
              ];
          }
        },
        (error) => {
          console.log(error);
          this.selectedLocation =
            ProjConstants.IDTOLOCATIONMAPPING[
              this.route.snapshot.paramMap.get("id")
            ];
        },
        "INDIA_BLOCK"
      );
    }
  }

  changeLayerStyleforThreshold(componentTyp?: string) {
    const uuidList: string[] = [];
    let layer: any;
    let styl = {};
    if (componentTyp === "humidity") {
      this.componentType = componentTyp;
    }
    if (this.componentType === "humidity") {
      styl = {
        stroke: false,
        color: "#0000FF",
        fill: true,
        fillColor: "#0000FF",
        fillOpacity: 0.4,
        opacity: 0.4,
      };
    }
    Object.keys(this.thresholdMap).forEach((key: string) => {
      if (this.hourCounter === "24hr") {
        if (key !== "type" && this.thresholdMap[key][4] === 1) {
          uuidList.push(key.toLowerCase());
        }
      } else {
        if (!isNullOrUndefined(this.counter) && this.counter > 0) {
          if (
            (key !== "type" && this.thresholdMap[key].length === 4) ||
            this.thresholdMap[key].length === 5
          ) {
            if (
              this.thresholdMap[key][
                Math.floor((this.counter - this.initialCounter) / 21600000)
              ] === 1
            ) {
              uuidList.push(key.toLowerCase());
            }
          } else {
            let counter = this.initialCounter;
            const currDate = new Date();
            const date1 = new Date();
            date1.setHours(5, 30, 0);
            const date2 = new Date();
            date2.setHours(11, 30, 0);
            const date3 = new Date();
            date3.setHours(17, 30, 0);
            const date4 = new Date();
            date4.setHours(23, 30, 0);
            if (currDate >= date1 && currDate < date2) {
              counter -= 21600000 * 0;
            } else if (currDate >= date2 && currDate < date3) {
              counter -= 21600000 * 1;
            } else if (currDate >= date3 && currDate < date4) {
              counter -= 21600000 * 2;
            } else {
              counter -= 21600000 * 3;
            }
            if (
              key !== "type" &&
              this.thresholdMap[key][
                Math.floor((this.counter - counter) / 86400000)
              ] === 1
            ) {
              uuidList.push(key.toLowerCase());
            }
          }
        } else if (key !== "type" && this.thresholdMap[key][0] === 1) {
          uuidList.push(key.toLowerCase());
        }
      }
    });

    if (this.thresholdMap["type"] === "District View") {
      for (const key of Object.keys(this.activeLayers)) {
        const layerName =
          ProjConstants.STATE_TO_LAYERTYPE_NAME[this.STATENAME + "_DISTRICT"];
        // console.log("Not Entered",this.activeLayers[key]);
        if (
          this.activeLayers[key].serviceType === "VectorLayer" &&
          this.activeLayers[key].layerName === layerName
        ) {
          // console.log("Hello",this.activeLayers[key]);
          layer = this.activeLayers[key].layer;
          this.map.removeLayer(layer);
          layer.options.vectorTileLayerStyles[layerName] = (properties) => {
            if (uuidList.includes(properties.uuid)) {
              if (this.componentType === "humidity") {
                return styl;
              } else {
                return this.style;
              }
            } else {
              const style = {
                opacity: 0,
              };
              return style;
            }
          };
          this.map.addLayer(layer);
        }
      }
    } else if (this.thresholdMap["type"] === "Basin View") {
      for (const key of Object.keys(this.activeLayers)) {
        const layerName =
          ProjConstants.STATE_TO_LAYERTYPE_NAME[this.STATENAME + "_BASIN"];
        if (
          this.activeLayers[key].serviceType === "VectorLayer" &&
          this.activeLayers[key].layerName === layerName
        ) {
          layer = this.activeLayers[key].layer;
          this.map.removeLayer(layer);
          layer.options.vectorTileLayerStyles[layerName] = (properties) => {
            if (uuidList.includes(properties.uuid)) {
              if (this.componentType === "humidity") {
                return styl;
              } else {
                return this.style;
              }
            } else {
              const style = {
                opacity: 0,
              };
              return style;
            }
          };
          this.map.addLayer(layer);
        }
      }
    } else if (this.thresholdMap["type"] === "Mandal View") {
      for (const key of Object.keys(this.activeLayers)) {
        const layerName =
          ProjConstants.STATE_TO_LAYERTYPE_NAME[this.STATENAME + "_BLOCK"];
        if (
          this.activeLayers[key].serviceType === "VectorLayer" &&
          this.activeLayers[key].layerName === layerName
        ) {
          layer = this.activeLayers[key].layer;
          this.map.removeLayer(layer);
          layer.options.vectorTileLayerStyles[layerName] = (properties) => {
            if (uuidList.includes(properties.uuid)) {
              if (this.componentType === "humidity") {
                return styl;
              } else {
                return this.style;
              }
            } else {
              const style = {
                opacity: 0,
              };
              return style;
            }
          };
          this.map.addLayer(layer);
        }
      }
    } else if (this.thresholdMap["type"] === "Sub-basin View") {
      for (const key of Object.keys(this.activeLayers)) {
        const layerName =
          ProjConstants.STATE_TO_LAYERTYPE_NAME[this.STATENAME + "_SUBBASIN"];
        if (
          this.activeLayers[key].serviceType === "VectorLayer" &&
          this.activeLayers[key].layerName === layerName
        ) {
          layer = this.activeLayers[key].layer;
          this.map.removeLayer(layer);
          layer.options.vectorTileLayerStyles[layerName] = (properties) => {
            if (uuidList.includes(properties.uuid)) {
              if (this.componentType === "humidity") {
                return styl;
              } else {
                return this.style;
              }
            } else {
              const style = {
                opacity: 0,
              };
              return style;
            }
          };
          this.map.addLayer(layer);
        }
      }
    } else if (Object.keys(this.thresholdMap).length === 0) {
      this.resetLayerStyle();
    }
  }

  resetLayerStyle() {
    for (const key of Object.keys(this.activeLayers)) {
      if (this.activeLayers[key].serviceType === "VectorLayer") {
        this.map.removeLayer(this.activeLayers[key].layer);
        this.activeLayers[key].layer.options.vectorTileLayerStyles[
          this.activeLayers[key].layerName
        ] = () => {
          const style = {
            opacity: 0,
          };
          return style;
        };
        this.map.addLayer(this.activeLayers[key].layer);
      }
    }
  }

  handleEventFromSearch(data) {
    if (this.rUview == "Urban") {
      Object.values(this.ulbCentroidData).forEach((element) => {
        if (
          element["latitude"] == data.location.lat &&
          element["longitude"] == data.location.long
        ) {
          this.ulbData.forEach((key) => {
            if (element["locUUID"] == key["ulbUUID"]) {
              this.utils.setULBselected(key);
            }
          });
          const uuid = element["locUUID"];
          if (
            !isNullOrUndefined(this.ulbLayer) &&
            this.map.hasLayer(this.ulbLayer["layer"])
          ) {
            this.map.removeLayer(this.ulbLayer["layer"]);
          }
          // this.addUrbanBodieLayers(this.layerList,uuid,true)
          // this.loadAllUrbanBodiesLayers()
        }
      });
    }
    this.map.flyTo(
      [data.location.lat, data.location.long],
      ProjConstants.LOCATION_ZOOM_MAPPING[data["et"]]
    );
  }

  changeStateBasedonUrlParams() {
    this.addLegend();
    if (this.otherOptions["urlParams"]) {
      this.urlParams = this.otherOptions["urlParams"];
      if (
        this.urlParams["mapOnClickParams"] == true ||
        this.urlParams["handleEventFromBreadcrumb"] == true
      ) {
        // console.log('Need to Add Zoom Functionality');
      } else {
        this.showThrobber = true;
        this.removeAllTimeLayers();
        this.serviceMap.addTimeBasedLayers(this, this.layerList);
        if (this.deviceInfo["deviceType"] === "desktop") {
          this.addLegend();
        }
      }
    } else {
      this.showThrobber = true;
      this.removeAllTimeLayers();
      this.serviceMap.addTimeBasedLayers(this, this.layerList);
      if (this.deviceInfo["deviceType"] === "desktop") {
        this.addLegend();
      }
      // this.addLegend();
    }
  }

  changePlayPos(event: any) {
    this.playPosition = event;
  }

  collapse(event: any) {
    this.collapsebutton = event;
  }

  activeMenu(event: any) {
    this.activeSideMenu = event;
  }

  createMultiPolygon(data: any) {
    let polyCoords = [];
    data.features.forEach((element: any) => {
      element.geometry.coordinates.forEach((el) => {
        el.forEach((elm) => {
          polyCoords = [];
          elm.forEach((elmnt) => {
            polyCoords.push(elmnt);
          });
          const poly = turf.polygon([polyCoords]);
          this.polygons.push(poly);
        });
      });
    });
  }

  checkIfPointInsidePolygon(latlng: any) {
    if (this.polygons.length > 0) {
      const point = turf.point([latlng.lng, latlng.lat]);
      let counter = 0;
      this.polygons.forEach((poly) => {
        if (turf.inside(point, poly)) {
          counter = 1;
        }
      });
      if (counter !== 1) {
        this.bottombarClick = false;
        // this.closeBottomBar(0);
        alert("No data present for the point");
        return false;
      }
    }
    return true;
  }

  changeAttribution() {
    if (!isNullOrUndefined(this.map)) {
      this.map.eachLayer((layer) => {
        if (
          !isNullOrUndefined(layer.options) &&
          !isNullOrUndefined(layer.options.attribution)
        ) {
          this.map.removeLayer(layer);
          if (this.sourceSelected === "IMD") {
            // layer.options.attribution = '<a href = \'https://mausam.imd.gov.in/\'> Data Source : IMD </a>';
          } else if (this.sourceSelected === "ECMWF") {
            // layer.options.attribution = '<a href = \'https://www.ecmwf.int/\'> Data Source : ECMWF </a>';
          } else {
            layer.options.attribution = "";
          }
          this.map.addLayer(layer);
        }
      });
    }
  }

  download(type: any) {
    let component = this.router.url.split("/")[2].toUpperCase();
    let application = this.router.url.split("/")[1];
    const forecastLength = this.router.url.split("/")[3];
    const view = this.view.toUpperCase();
    if (this.router.url.split("/")[2].toUpperCase() == "TEMPERATURE") {
      component = component + "_" + this.minMax.toUpperCase();
    }
    if (this.router.url.split("/")[3] == "weekly") {
      component = component + "_" + this.meanMedian.toUpperCase();
    }
    // console.log("here", component, forecastLength, this.sourceSelected, view)
    if (type == "download") {
      if (application == "extremeweather") {
        this.mapService
          .getpdfDownload(
            component,
            this.sourceSelected,
            forecastLength,
            null,
            view
          )
          .subscribe((data) => {
            const filename = "Report" + new Date().getTime() + ".pdf";
            const PDF_TYPE = "application/pdf;charset=utf-8";
            if (!data) {
              return;
            }
            const blob = new Blob([data], { type: PDF_TYPE });
            const objectUrl = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = objectUrl;
            a.download = filename;
            a.target = "_blank";
            a.click();
          });
      } else if (application == "observedweather") {
        let view;
        component = component.split("-")[0];
        if (this.otherOptions["urlParams"]) {
          view = this.otherOptions["urlParams"]["view"];
        }
        this.mapService
          .getpdfDownloadForOW(component, view)
          .subscribe((data) => {
            const filename = "Report" + new Date().getTime() + ".pdf";
            const PDF_TYPE = "application/pdf;charset=utf-8";
            if (!data) {
              return;
            }
            const blob = new Blob([data], { type: PDF_TYPE });
            const objectUrl = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = objectUrl;
            a.download = filename;
            a.target = "_blank";
            a.click();
          });
      } else if (application == "heatwatches") {
        this.mapService
          .getpdfDownloadForHW(
            component,
            this.sourceSelected,
            forecastLength,
            null,
            view
          )
          .subscribe((data) => {
            const filename = "Report" + new Date().getTime() + ".pdf";
            const PDF_TYPE = "application/pdf;charset=utf-8";
            if (!data) {
              return;
            }
            const blob = new Blob([data], { type: PDF_TYPE });
            const objectUrl = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = objectUrl;
            a.download = filename;
            a.target = "_blank";
            a.click();
          });
      }
    } else {
      let image;
      if (application == "extremeweather") {
        this.mapService
          .getImage(component, this.sourceSelected, forecastLength, null, view)
          .subscribe((res) => {
            if (res) {
              const reader = new FileReader();
              reader.addEventListener(
                "load",
                () => {
                  image = reader.result;
                  const modalRef = this.modalService.open(ShareModalComponent, {
                    backdrop: "static",
                    keyboard: false,
                    size: "lg",
                    windowClass: "backgroundTransparent",
                  });
                  modalRef.componentInstance.imageUrl = res;
                  modalRef.componentInstance.image = image;
                  modalRef.componentInstance.source = this.sourceSelected;
                  modalRef.componentInstance.component = component;
                  modalRef.componentInstance.view = view;
                  modalRef.componentInstance.application = application;
                },
                false
              );
              if (res) {
                if (res.type !== "application/pdf") {
                  reader.readAsDataURL(res);
                }
              }
            }
          });
      } else if (application == "observedweather") {
        let view;
        if (this.otherOptions["urlParams"]) {
          view = this.otherOptions["urlParams"]["view"];
        }
        component = component.split("-")[0];
        this.mapService.getImageForOW(component, view).subscribe((res) => {
          if (res) {
            const reader = new FileReader();
            reader.addEventListener(
              "load",
              () => {
                image = reader.result;
                const modalRef = this.modalService.open(ShareModalComponent, {
                  backdrop: "static",
                  keyboard: false,
                  size: "lg",
                  windowClass: "backgroundTransparent",
                });
                modalRef.componentInstance.imageUrl = res;
                modalRef.componentInstance.image = image;
                modalRef.componentInstance.component = component;
                modalRef.componentInstance.view = view;
                modalRef.componentInstance.application = application;
              },
              false
            );
            if (res) {
              if (res.type !== "application/pdf") {
                reader.readAsDataURL(res);
              }
            }
          }
        });
      } else if (application == "heatwatches") {
        this.mapService
          .getImageForHW(
            component,
            this.sourceSelected,
            forecastLength,
            null,
            view
          )
          .subscribe((res) => {
            if (res) {
              const reader = new FileReader();
              reader.addEventListener(
                "load",
                () => {
                  image = reader.result;
                  const modalRef = this.modalService.open(ShareModalComponent, {
                    backdrop: "static",
                    keyboard: false,
                    size: "lg",
                    windowClass: "backgroundTransparent",
                  });
                  modalRef.componentInstance.imageUrl = res;
                  modalRef.componentInstance.image = image;
                  modalRef.componentInstance.source = this.sourceSelected;
                  modalRef.componentInstance.component = component;
                  modalRef.componentInstance.view = view;
                  modalRef.componentInstance.application = application;
                },
                false
              );
              if (res) {
                if (res.type !== "application/pdf") {
                  reader.readAsDataURL(res);
                }
              }
            }
          });
      }
    }
  }

  reloadAllTimeLayers() {
    this.showThrobber = true;
    this.removeAllTimeLayers();
    this.serviceMap.addTimeBasedLayers(this, this.layerList);
    if (this.deviceInfo["deviceType"] === "desktop") {
      this.addLegend();
    }
    // this.addLegend();
  }

  reloadAllActualTimeLayers() {
    // this.showThrobber = true;
    this.removeAllTimeLayers();
    this.serviceMap.addActualTimeLayers(this, this.layerList);
    if (this.deviceInfo["deviceType"] === "desktop") {
      this.addLegend();
    }
    // this.addLegend();
  }

  updateSource() {
    let tempSrcList = [];
    this.utils.getExtremeWeatherSourceList().subscribe((data) => {
      tempSrcList = [];
      data.forEach((element) => {
        tempSrcList.push(element.source);
      });
      this.utils.setSourceList(tempSrcList);
    });

    //  this.showHWdownload=data['download'];
    //  this.Value.uuid=data['uuid'];
  }

  changeSource(value) {
    this.utils.setImdEcmwf(value);
  }

  setShowOptions() {
    this.showOptions = !this.showOptions;
    if (this.showOptions) this.optionAndClose = "close";
    else this.optionAndClose = "Options";
  }

  logOut() {
    this.loginStatus.emit(false);
    this.utils.clearLogin();
    this.utils.setLoginPrompt(false);
    this.isLoggedIn = false;
  }
  userButton() {
    this.utils.setShowLoginBox(true);
  }
  getClose(value) {
    this.showLogin = false;
  }

  getLogin(value) {
    this.isLoggedIn = value;
    this.utils.setLoginPrompt(value);
    this.loginStatus.emit(this.isLoggedIn);
  }

  translation(language) {
    // this.translate.use(language);
    this.lang = language;
    localStorage.setItem("lang", this.lang);
    // this.utils.setLanguage(this.lang);
    console.log("lanfg", this.lang);
  }
  /**
   * @author Akhil
   */
  mapControlContainer() {
    if (this.dataTabToggleVal) {
      if (document.getElementById("MapContainer").offsetWidth < 1600) {
        document.documentElement.style.setProperty("--opacite", "none");
        document.documentElement.style.setProperty("--lPercent", "70%");
      }
    } else {
      document.documentElement.style.setProperty("--opacite", "display");
      document.documentElement.style.setProperty("--lPercent", "50%");
    }
  }

  infoclick(value) {
    this.modalRef = this.modalService.open(InfomodalComponent, {
      backdrop: "static",
      keyboard: true,
      windowClass: "backgroundTransparent  infocomponent",
    });
    this.modalRef.componentInstance.selected = value;
  }

  showHeatWaveToggle: boolean = true;
  showHeatWave() {
    this.showHeatWaveToggle = !this.showHeatWaveToggle;
  }

  updateDistrict(event) {
    this.Value = event.target.value;
    this.Value = JSON.parse(this.Value);
    this.map.setView([this.Value.centroid.lat, this.Value.centroid.lon], 7);
    // this.StateSelected.emit({
    //   state: this.Value.State.val,
    //   stateUUID:this.Value.uuid,
    // })
    this.utils.setStateClicked(this.Value.uuid);
    this.stateSelect.name = this.Value.State.val;
    this.stateSelect.centroid = this.Value.centroid;
    this.stateSelect.uuid = this.Value.uuid;
    this.districtWise = true;
    this.countryName = false;
    this.stateName = true;
    this.stateWise = true;
    this.showD1 = false;
    this.showD2 = true;
    this.showHWdownload = true;

    return this.Value;
  }
  updateDistrict2(event) {
    let value = event.target.value;
    value = JSON.parse(value);
    this.districtSelected.emit({
      district: value.District.val,
      districtUUID: value.uuid,
    });
    this.utils.setDistrictsClicked(value.uuid);
    this.map.setView([value.centroid.lat, value.centroid.lon], 11);
    this.districtSelect.name = value.District.val;
    this.districtWise = true;
    this.countryName = false;
    this.stateName = true;
    this.showD2 = false;

    // this.districtName =true;

    return value;
  }

  changeView(params: String) {
    let centroid;
    if (params == "Country" && this.locType != 'Country') {
      console.log("inside country");
        // this.districtwise =false;
      // this.statewise = true;
      this.locType = 'Country';
      centroid = [20.5937, 78.9629];
      this.map.setView(centroid, 5);
      this.countryWise = true;
      this.stateWise = true;
      this.districtWise = false;
      this.stateSelect.name = "State";
      this.districtSelect.name = "District";
      this.countryName = true;
      this.stateName = false;
      this.districtName = false;
      this.showD1 = true;
      this.showD2 = false;
      this.showHWdownload = false;

      this.utils.setCountryNameClicked(this.countryWise);
    } else if (params == "State") {
      this.locType = 'State';
      centroid = [this.stateSelect.centroid.lat, this.stateSelect.centroid.lon];
      this.map.setView(centroid, 7);
      this.districtSelect.name = "";
      this.districtWise = false;
      this.stateWise = true;
      this.utils.setStateClicked(this.stateSelect.uuid);
      this.showD2 = true;
      this.showD1 = false;
    } else if (params == "District") {
      this.locType = 'District';
      console.log("inside district");
      // centroid = [this.stateSelect.centroid.lat, this.stateSelect.centroid.lon]
      // this.map.setView(centroid,7)
      this.districtWise = false;
      this.showD2 = true;
    }
}
  heatWaveReport() {
    this.showThrobber = true;
    const source = this.selectedSource || 'IMD_LONG_RANGE'; // Default to 'IMD_LONG_RANGE' if no source is selected

    if (this.locType === 'Country') {
      this.mapService.getStateHeatWaveDownload(source).subscribe(
        (data) => this.downloadReport(data,'Heat_Wave'),     // country level
        (error) => {
          console.error('Error downloading the report:', error);
          this.showThrobber = false;
        }
      );
    } else if (this.locType === 'State') {
      this.mapService.getHeatWaveDownload(this.fetchedUUID).subscribe(
        (data) => this.downloadReport(data,'Heat_Wave'), // state level
        (error) => {
          console.error('Error downloading the report:', error);
          this.showThrobber = false;
        }
      );
    }
  }

  coldWaveReport() {
    this.showThrobber = true;
    const source = this.selectedSource || 'IMD_LONG_RANGE'; // Default to 'IMD_LONG_RANGE' if no source is selected

    if (this.locType === 'Country') {
      this.mapService.getCountryColdWaveDownload(source).subscribe(
        (data) => this.downloadReport(data,'Cold_Wave'),     // country level
        (error) => {
          console.error('Error downloading the report:', error);
          this.showThrobber = false;
        }
      );
    } else if (this.locType === 'State') {
      this.mapService.getColdWaveDownload(this.fetchedUUID).subscribe(
        (data) => this.downloadReport(data,'Cold_Wave'), // state level
        (error) => {
          console.error('Error downloading the report:', error);
          this.showThrobber = false;
        }
      );
    }
  }

  private downloadReport(data: Blob,fileName:any) {
    const filename = fileName + "_Report" + ".pdf";
    const PDF_TYPE = "application/pdf;charset=utf-8";
    if (!data) {
      this.showThrobber = false;
      return;
    }
    const blob = new Blob([data], { type: PDF_TYPE });
    const objectUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = filename;
    a.target = "_blank";
    a.click();
    setTimeout(() => {
      this.showThrobber = false;
    });
  }

  routeChange(type:any) {
    if(type != this.activeButton) {
      this.activeButton = type;
      this.utilService.setNowcastView(type)
    }
    if(type == 'Cityalerts'){
      this.cityAlertsDisable = false;
    } else if(type == 'Admin'){
      this.cityAlertsDisable = true;
    }
  }

  routeToNowcast() {
    this.router.navigate(['', 'nowcastweather', 'forecast', 'akbm'])
  }



  // public logoutUser() {

  //   let postData = new URLSearchParams();

  //   //* Append the required parameters to the post data
  //   let refreshToken = localStorage.getItem('refreshToken');
  //   console.log("refreshToken",refreshToken);

  //   postData.append('client_id', 'heatwaveClient');
  //   console.log("postData before refresh tokemn",postData);

  //   if (!isNullOrUndefined(refreshToken)) {
  //     postData.append('refresh_token', <any>refreshToken);
  //   }

  //   console.log("postData aftre refresh tokemn",postData);

  //   //* The base url for logout (project specific)
  //   let logoutBaseUrl = environment.url.USERMANAGEMENT_URL+"auth/realms";

  //   //* The realm name configured in keycloak for this project
  //   let realmName = "heatwaveRealm";

  //   //* The base url of user management configured for this project
  //   let userManagementBaseUrl = environment.url.USERMANAGEMENT_URL;

  //   let finalBaseUrl = `${logoutBaseUrl}/${realmName}/protocol/openid-connect/logout`;
  //   console.log("finalBaseUrl",finalBaseUrl);
  //   console.log("localStorage.getItem('token')",localStorage.getItem('token'));

  //   console.log("postData",postData.toString());

  //   this.http.post(finalBaseUrl, postData.toString(), {
  //     headers: {
  //       'Content-Type': 'application/x-www-form-urlencoded',
  //       'Authorization': 'Bearer ' + localStorage.getItem('token')
  //     },
  //     observe: 'response'
  //   }).subscribe((data: any) => {

  //     //* If you receive a 204 response, clear the tokens and redirect to the user management base url.
  //     if (data.status === 204) {
  //       localStorage.clear();
  //       console.log('logged out');
  //       window.location.href = userManagementBaseUrl;
  //     }
  //   })}

  //   userManagement(){
  //     document.location.href = environment.url.USERMANAGEMENT_URL+'users';
  //   }
  // formatDateString(dateString: string): string {
  //   console.log(dateString,"date string");
  //   let year = Number(dateString.substring(0, 4));
  //   let month = Number(dateString.substring(4, 6)) - 1
  //   let day = Number(dateString.substring(6, 8));
  //   let date = new Date(Number(year), Number(month), Number(day));
  //   return this.datePipe.transform(date, 'dd-MMM-yyyy', '+0530') + ' GMT+05:30';
  // }

  formatDateString(timestamp: number): string {
    // console.log(timestamp, "timestamp");
    let date = new Date(timestamp);
    return this.datePipe.transform(date, 'dd-MMM-yyyy hh:mm a', '+0530');
  }

  layerToggle(type:any) {
    this.actualView = type
    this.reloadAllActualTimeLayers()
    // this.utilService.layerType.next(type);
  }

  onClickTaskManager(){
    this.openTaskManager.emit(true);
  }

}
